<template>
  <el-table-column
    prop="unit_price"
    label="Egységár"
    width="130"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.unit_price | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'unit_price',
};
</script>
